import { GetterTree } from 'vuex';

import { snakeToCamel } from '@/utils';
import { decode } from '@/utils/custom-enc-dec';

import { ProjectsStateI } from './state';
import { RootStateI } from '../state';

// eslint-disable-next-line @typescript-eslint/naming-convention
type ProjectUser = { userId?: number; role: string };

const getCurrentUserId = (): number | null => {
  const uEncoded = localStorage.getItem('user');
  if (!uEncoded) return null;

  try {
    const { value } = decode(uEncoded);
    const u = JSON.parse(value as string);
    const user = snakeToCamel(u);
    return user.id;
  } catch {
    return null;
  }
};

export const getters: GetterTree<ProjectsStateI, RootStateI> = {
  currentRole: (state) => {
    const userId = getCurrentUserId();
    if (!userId || !state.project?.users) {
      console.debug('[projects/currentRole] Missing userId or project.users', { userId, hasUsers: !!state.project?.users });
      return null;
    }
    const projectUser = state.project.users.find((u: ProjectUser) => u.userId === userId);
    console.debug('[projects/currentRole]', { userId, projectUsers: state.project.users, found: !!projectUser, role: projectUser?.role });
    return projectUser ? projectUser.role : null;
  },
  canEdit: (state, _getters) => {
    const role = _getters.currentRole;
    return role === 'owner' || role === 'editor';
  },
  isOwner: (state, _getters) => _getters.currentRole === 'owner',
  canInvite: (state) => {
    const projectUsers = state.project?.users;
    if (!projectUsers) return false;

    const userId = getCurrentUserId();
    if (!userId) return false;

    console.log('projectUsers->', projectUsers);
    const currentUser = projectUsers.find((cu: ProjectUser) => cu.userId === userId);
    console.log('currentUser->', currentUser);

    return currentUser?.role === 'owner';
  },
};
